import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import OperationMenuDots from 'modules/_shared/components/MenuDots/OperationMenuDots';
import OperationTypesSelector from 'modules/transactions/components/OperationTypesSelector';
import { useGetOperationsMenu } from 'modules/transactions/hooks/useGetOperationsMenu';

import OperationsListPageBody from './components/OperationsListPageBody';
import { useOperationsListPage } from './context/OperationsListPageContext';

const OperationsList: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useOperationsListPage();

  const { data: operationsMenu } = useGetOperationsMenu();

  const pageActions = [
    <OperationTypesSelector onChangeTypes={actions.handleChangeFilter} />,
    <OperationMenuDots
      menuOptions={operationsMenu}
      handleModal={null}
      params={{ society: data.society }}
      disabled={data.isReadOnly}
    />,
  ];

  return (
    <Page>
      <PageListHeader
        subTitle={t('Operations')}
        description={`${data.society?.name} ${t('HaveOperations', {
          count: data.operationsTotal,
        })}`}
        actions={data.isAdmin && !data.isReadOnly ? pageActions : []}
      />

      <OperationsListPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default OperationsList;
